import React from 'react';
import { Box, MenuItem, Typography, Avatar, Button, Divider } from '@mui/material';
import FeatherIcon from 'feather-icons-react';

import userimg from '../../../assets/images/users/3.jpg';

const ProfileDropdown = ({loggedUser}) => (
  <Box>
    <Box
      sx={{
        pb: 3,
        mt: 3,
      }}
    >
      <Box display="flex" alignItems="center">
        <Avatar
          sx={{
            width: '70px',
            height: '70px',
          }}
        >
          {String(loggedUser?.nom).charAt(0).toUpperCase() + String(loggedUser?.prenom).charAt(0).toUpperCase()}
        </Avatar>
        <Box
          sx={{
            ml: 2,
          }}
        >
          <Typography
            variant="h4"
            sx={{
              lineHeight: '1.235',
            }}
          >
            {`${loggedUser?.nom} ${loggedUser?.prenom}`}
          </Typography>
          <Typography color="textSecondary" variant="h6" fontWeight="400">
            {loggedUser?.role}
          </Typography>
          <Box display="flex" alignItems="center">
            <Typography
              color="textSecondary"
              display="flex"
              alignItems="center"
              sx={{
                color: (theme) => theme.palette.grey.A200,
                mr: 1,
              }}
            >
              <FeatherIcon icon="mail" width="18" />
            </Typography>
            <Typography color="textSecondary" variant="h6">
              {loggedUser?.email}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
    <Divider
      style={{
        marginTop: 0,
        marginBottom: 0,
      }}
    />

    {/* <Box>

      <Divider
        style={{
          marginTop: 0,
          marginBottom: 0,
        }}
      />
      <MenuItem
        sx={{
          pt: 3,
          pb: 3,
        }}
      >
        <Box display="flex" alignItems="center">
          <Button
            sx={{
              backgroundColor: (theme) => theme.palette.success.light,
              color: (theme) => theme.palette.success.main,
              boxShadow: 'none',
              minWidth: '50px',
              width: '45px',
              height: '40px',
              borderRadius: '10px',
            }}
          >
            <FeatherIcon icon="shield" width="18" height="18" />
          </Button>
          <Box
            sx={{
              ml: 2,
            }}
          >
            <Typography
              variant="h5"
              sx={{
                lineHeight: '1.235',
              }}
            >
              My Inbox
            </Typography>
            <Typography color="textSecondary" variant="h6" fontWeight="400">
              Messages & Emails
            </Typography>
          </Box>
        </Box>
      </MenuItem>
      <Divider
        style={{
          marginTop: 0,
          marginBottom: 0,
        }}
      />
      <MenuItem
        sx={{
          pt: 3,
          pb: 3,
        }}
      >
        <Box display="flex" alignItems="center">
          <Button
            sx={{
              backgroundColor: (theme) => theme.palette.error.light,
              color: (theme) => theme.palette.error.main,
              boxShadow: 'none',
              minWidth: '50px',
              width: '45px',
              height: '40px',
              borderRadius: '10px',
            }}
          >
            <FeatherIcon icon="credit-card" width="18" height="18" />
          </Button>
          <Box
            sx={{
              ml: 2,
            }}
          >
            <Typography
              variant="h5"
              sx={{
                lineHeight: '1.235',
              }}
            >
              My Tasks
            </Typography>
            <Typography color="textSecondary" variant="h6" fontWeight="400">
              To-do and Daily Tasks
            </Typography>
          </Box>
        </Box>
      </MenuItem>
    </Box> */}
  </Box>
);

export default ProfileDropdown;
